import React from 'react';

const SvgComponent: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg style={{ width: '100%', display: 'block' }} viewBox="0 0 88 87" {...props}>
    <g fillRule="nonzero" fill="none">
      <rect fill={props.color || '#E23E7C'} x={0.47} y={0.4} width={86.6} height={86.6} rx={43.3} />
      <g fill="#FFF">
        <path
          d="M43.77 16.64L20.33 30.17v27.06l23.44 13.53 23.44-13.53V30.17L43.77 16.64zm11.72 33.82l-11.72 6.77-11.72-6.77V36.93l11.72-6.77 11.72 6.77v13.53z"
          opacity={0.5}
        />
        <path
          opacity={0.5}
          d="M55.49 23.4L32.05 36.93V23.4l11.72-6.77zM32.05 64l23.44-13.53V64l-11.72 6.77z"
        />
        <path
          opacity={0.9}
          d="M20.33 43.7l23.44 13.53L32.05 64l-11.72-6.77zM67.2 43.7L43.76 30.17l11.72-6.77 11.72 6.77V43.7z"
        />
      </g>
    </g>
  </svg>
);

export default SvgComponent;
